import { NgModule } from '@angular/core';
import { WorkWidgetHeaderComponent } from './work-widget-header.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';
import { SvgAvatarModule } from '../svg-avatar';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from '../tooltip/tooltip.module';
import { LaneButtonsModule } from '../lane-buttons/lane-buttons.module';
import { CompactVisitorInfoModule } from '../compact-visitor-info/compact-visitor-info.module';
import { AvatarModule } from 'shared/components/avatar/avatar.module';

@NgModule({
  imports: [
    TranslateModule.forChild(),
    CommonModule,
    SvgIconModule,
    SvgAvatarModule,
    TooltipModule,
    LaneButtonsModule,
    CompactVisitorInfoModule,
    AvatarModule
  ],
  declarations: [
    WorkWidgetHeaderComponent
  ],
  exports: [
    WorkWidgetHeaderComponent
  ]
})
export class WorkWidgetHeaderModule {}
